/** Build display initials (up to 2 chars) from the available name parts or email. */
export const computeInitials = (
  firstName: string | null | undefined,
  lastName: string | null | undefined,
  email?: string | null,
): string => {
  const first = (firstName ?? '').trim()
  const last = (lastName ?? '').trim()
  if (first && last) return (first[0]! + last[0]!).toUpperCase()
  if (first.length >= 2) return first.slice(0, 2).toUpperCase()
  if (last.length >= 2) return last.slice(0, 2).toUpperCase()
  if (first) return first[0]!.toUpperCase()
  if (last) return last[0]!.toUpperCase()
  const e = (email ?? '').trim()
  if (e.length >= 2) return e.slice(0, 2).toUpperCase()
  if (e.length === 1) return e[0]!.toUpperCase()
  return '?'
}
